<template>
  <div class="BioDetail main_style">
    <Main_nav />
    <searchBar />
    <b-container style="position: relative" class="mt-3">
      <b-button
        style="border: 0; color: #828282; background: transparent"
        @click="$router.push('/SearchResult')"
        class="back-button"
        ><b-icon-arrow-left-circle></b-icon-arrow-left-circle> ย้อนกลับ
      </b-button>
      <div class="d-flex justify-content-center">
        <div>
          <div>
            <b-col cols="12" style="display: flex; height: 250px"
              ><img
                v-if="selectPlant.image.length > 0"
                :src="
                  domain +
                  (selectedImage
                    ? selectedImage
                    : selectPlant.image[0].image_url)
                "
                style="
                  margin: auto;
                  width: auto;
                  height: 100%;
                  max-height: 250px;
                "
                class="img-fluid img-thumbnail pointer"
              />
              <img
                v-else
                class="img-fluid img-thumbnail pointer"
                style="max-height: 250px"
                :src="require(`../assets/images/no-image.png`)"
              />
            </b-col>
          </div>
          <div
            v-if="selectPlant.image.length > 0"
            class="mt-3 d-flex justify-content-center image-flow-x"
          >
            <b-col
              v-for="(item, index) in selectPlant.image"
              :key="index"
              cols="4"
              style="display: flex; height: 100px"
              v-if="index <= 2"
              ><img
                :src="`${domain}${item.image_url}`"
                class="img-fluid pointer"
                style="
                  margin: auto;
                  width: 100%;
                  height: auto;
                  max-height: 100px;
                "
                @click="selectedImage = item.image_url"
            /></b-col>
          </div>
        </div>
        <div class="content-plant text-left">
          <p class="mt-5" style="font-size: 24px; font-weight: bold">
            {{ selectPlant.bio_name }}
          </p>
          <p>
            <span style="color: #5a7e64">ชื่อวิทยาศาสตร์ :</span>
            <template v-if="selectPlant.bio_scientific_name">
              <span
                v-if="selectPlant.bio_scientific_name"
                style="font-style: italic"
              >
                {{ selectPlant.bio_scientific_name }}
              </span>
              <span v-if="selectPlant.author_name">{{
                selectPlant.author_name
              }}</span>
              <!--              <template-->
              <!--                v-for="(text, i) in selectPlant.bio_scientific_name.split(' ')"-->
              <!--              >-->
              <!--                <span-->
              <!--                  v-if="-->
              <!--                    i == selectPlant.bio_scientific_name.split(' ').length - 1-->
              <!--                  "-->
              <!--                  >{{ text }}</span-->
              <!--                >-->
              <!--                <span v-else style="font-style: italic">{{ text + " " }}</span>-->
              <!--              </template>-->
            </template>
          </p>
          <p>
            <span style="color: #5a7e64">กลุ่มชนิดพืช :</span>
            {{ selectPlant.category.name }}
          </p>
          <p>
            <span style="color: #5a7e64">ลักษณะวิสัย :</span>
            <!--            {{-->
            <!--              Array.isArray(-->
            <!--                selectPlant.listofplant[selectPlant.listofplant.length - 1]-->
            <!--                  .habits-->
            <!--              )-->
            <!--                ? "true"-->
            <!--                : "false"-->
            <!--            }}-->
            <template
              v-if="
                Array.isArray(
                  selectPlant.listofplant[selectPlant.listofplant.length - 1]
                    .habits
                )
              "
            >
              <template
                v-for="(x, i) in selectPlant.listofplant[
                  selectPlant.listofplant.length - 1
                ].habits"
              >
                {{ x.name }}
                <template
                  v-if="
                    i !=
                    selectPlant.listofplant[selectPlant.listofplant.length - 1]
                      .habits.length -
                      1
                  "
                  >,</template
                >
              </template>
            </template>
            <template v-else>
              {{
                selectPlant.listofplant[selectPlant.listofplant.length - 1]
                  .habits.name
              }}
            </template>
          </p>
        </div>
      </div>
      <div class="mt-4 d-flex justify-content-center">
        <div class="community-detail">
          <DetailsBio
            :data="selectPlant.community"
            :plantCount="selectPlant.plant_count"
            :bankCount="selectPlant.bank_count"
          />
        </div>
      </div>
      <b-row style="margin-bottom: 150px"></b-row>
    </b-container>
  </div>
</template>
<script>
import Main_nav from "@/components/navbar";
import searchBar from "@/components/searchBar";
import { mapState } from "vuex";
import { domain } from "@/utils/Constants";
import Swal from "sweetalert2";
import DetailsBio from "@/components/DetailsBio";

export default {
  name: "BioDetail",
  data() {
    return {
      selectedImage: "",
      domain: domain,
      plant: {
        scientific: "Centella Asiatica",
        local: "ผักแว่น ผักหนอก ",
        group: "สมุนไพร",
        type: "ไม้ล้มลุก",
        source: "สวนครัว",
        season: "ทุก 2-3 เดือน",
        found: 8,
        collect: 5,
        image: [
          "detail_2.png",
          "detail_1.png",
          "detail_2.png",
          "detail_1.png",
          "detail_2.png",
        ],
        property:
          "เป็นไม้ล้มลุกทอดเลื้อยไปตามพื้นดิน มีรากออกตามข้อชูใบตั้งตรงขึ้นมา ใบเป็นใบเดี่ยวมีก้านชูใบยาว ลักษณะเป็นรูปไตหรือรูปกลม มีรอยเว้าลึกที่ฐานขอบใบมีรอยหยักผิวในด้านบนเรียบ",
        community: [
          {
            id: 1,
            name: "บ้านเมืองกื้ด",
            part: "ใบสด",
            description:
              "ใช้เป็นยาภายนอกรักษาแผลเปื่อย แผลไฟไหม้น้ําร้อนลวก น้ําต้ม",
          },
          {
            id: 2,
            name: "ชุมชนวังส้มซ่า",
            part: "ดอก",
            description:
              "ดื่มลดไข้ รักษาโรคปากเปื่อย ปากเหม็น เจ็บคอ ร้อนใน กระหายน้ําขับปัสสาวะ ",
          },
        ],
      },
      color: {
        0: "red",
        1: "blue",
        2: "green",
      },
      allColor: 3,
    };
  },
  methods: {
    // getColor(id) {
    //   console.log(this.color[1]);
    //   // return this.color[id];
    // },
    openCommunityLink(id) {
      window.open("/CommunityDetail/" + id);
    },
    countCommunity(community) {
      let communityArray = community.split(",");
      return communityArray.length;
    },
    changeImage(url) {
      this.selectedImage = url;
    },
    queryImage() {
      if (this.selectedImage) {
        return this.domain + this.selectedImage;
      } else {
        if (this.selectPlant.image.length > 0) {
          return this.domain + this.selectPlant.image[0].image_url;
        } else {
          return require(`../assets/images/no-image.png`);
        }
      }
    },
    gotoCommunity(id) {
      this.$router.push({ name: "CommunityDetail", params: { id: id } });
    },
  },
  computed: {
    ...mapState({
      selectPlant: (state) => state.viewModule.select_plant,
    }),
  },
  created() {
    Swal.fire({
      title: "ระบบกำลังทำงาน",
      html: "โปรดรอสักครู่...",
      allowEscapeKey: false,
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
        this.$store
          .dispatch("viewModule/onGetPlantDetail", this.$route.params.id)
          .then((res) => {
            if (res == 200) {
              Swal.clickConfirm();
            } else {
              Swal.clickConfirm();
            }
          });
      },
    });
  },
  components: {
    DetailsBio,
    Main_nav,
    searchBar,
  },
};
</script>

<style scoped lang="scss">
.color_1 {
  color: red;
}
.color_2 {
  color: blue;
}
.content-plant {
  background: #faf8f8;
  padding-left: 4%;
  max-width: 40%;
  min-width: 40%;
}
.community-detail {
  max-width: 65%;
  min-width: 65%;
}
.back-button {
  text-align: left;
  width: 100% !important;
}
@media (max-width: 992px) {
  .community-detail {
    max-width: 80%;
    min-width: 80%;
  }
}
@media (max-width: 767px) {
  .community-detail {
    max-width: 100%;
    min-width: 100%;
  }
}
</style>
